import { compose, withState } from 'recompose'
import BaseComponent from '../BaseComponent'
import PickPage from '../pages/Pick'
import React from 'react'
import _ from 'lodash'
import { calcExerciseId } from '../isomorphic/db'
import database from 'firebase/database'

// https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
const makeCancelable = promise => {
	let hasCanceled_ = false

	const wrappedPromise = new Promise((resolve, reject) => {
		promise.then(
			val => (hasCanceled_ ? reject({ isCanceled: true }) : resolve(val)),
			error => (hasCanceled_ ? reject({ isCanceled: true }) : reject(error))
		)
	})

	return {
		promise: wrappedPromise,
		cancel() {
			hasCanceled_ = true
		}
	}
}

export default compose(
	withState('other', 'setOther', ''),
	withState('submittingOther', 'setSubmittingOther', false)
)(
	class PickContainer extends BaseComponent {
		constructor() {
			super()
			this.state = {
				loading: true,
				exercises: {}
			}

			this.updateExercises = this.updateExercises.bind(this)
			this.createExercise = this.createExercise.bind(this)
		}

		createExercise() {
			const exercise = {
				title: this.props.other
			}

			const exerciseId = calcExerciseId(this.props.other)
			return new Promise(resolve =>
				database().ref(`exercises/${exerciseId}`).set(exercise, resolve(exerciseId))
			)
		}

		updateExercises() {
			// Note: Would be nice to abort the fetch rather than cancel the promise
			// * Once fetch supports abortions
			// * https://github.com/whatwg/fetch/issues/447
			// eslint-disable-next-line no-process-env
			const functionBase = process.env.REACT_APP_FIREBASE_functionBase
			this.fetchingSuggestedExercises = makeCancelable(
				fetch(`${functionBase}suggestedExercises`)
			)
			this.fetchingSuggestedExercises.promise
				.then(response => response.json())
				.then(exercises => this.setState({ exercises, loading: false }))
				.catch(_.noop)
		}

		componentWillUnmount() {
			this.fetchingSuggestedExercises.cancel()
		}

		componentWillMount() {
			this.updateExercises()
		}

		render() {
			const methods = {
				createExercise: this.createExercise
			}
			return <PickPage {...this.state} {...this.props} {...methods} />
		}
	}
)



// WEBPACK FOOTER //
// ./src/containers/PickContainer.js